import { render, staticRenderFns } from "./ConsolidaPedidosFornecedores.vue?vue&type=template&id=27540999&scoped=true"
import script from "./ConsolidaPedidosFornecedores.vue?vue&type=script&lang=js"
export * from "./ConsolidaPedidosFornecedores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27540999",
  null
  
)

export default component.exports